import { render, staticRenderFns } from "./GenericPricingComponent.vue?vue&type=template&id=38fef9bc"
import script from "./GenericPricingComponent.vue?vue&type=script&lang=ts"
export * from "./GenericPricingComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports